/* Small enhancements; native Shopify navigation, purchase and checkout remain authoritative. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-st-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const trigger = document.querySelector(`[aria-controls="${CSS.escape(menu.id)}"][data-st-menu-open]`);
      if (!trigger || !menu.showModal) return;
      trigger.hidden = false;
      const close = () => menu.close();
      trigger.addEventListener('click', () => { menu.showModal(); trigger.setAttribute('aria-expanded', 'true'); });
      menu.querySelector('[data-st-menu-close]')?.addEventListener('click', close);
      menu.addEventListener('click', e => { if (e.target === menu || e.target.closest('a')) close(); });
      menu.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); trigger.focus({ preventScroll: true }); });
    });
    root.querySelectorAll('[data-st-wall]').forEach(studio => {
      if (studio.dataset.ready) return;
      const data = studio.querySelector('[data-st-wall-products]');
      if (!data) return;
      let products;
      try { products = JSON.parse(data.textContent); } catch (_) { return; }
      const byHandle = new Map(products.map(p => [p.handle, p]));
      const slots = [...studio.querySelectorAll('[data-st-slot]')];
      const positions = [...studio.querySelectorAll('[data-st-position]')];
      const select = studio.querySelector('[data-st-motif]');
      if (!slots.length || !select) return;
      studio.dataset.ready = 'true';
      let active = 1;
      const update = (announce = false) => {
        const slot = slots[active];
        const product = byHandle.get(slot.dataset.handle);
        if (!product) return;
        slots.forEach((s, i) => s.setAttribute('aria-pressed', String(i === active)));
        positions.forEach((s, i) => s.setAttribute('aria-pressed', String(i === active)));
        select.value = product.handle;
        studio.querySelector('[data-st-wall-title]').textContent = product.title;
        studio.querySelector('[data-st-wall-price]').textContent = product.price;
        studio.querySelector('[data-st-wall-link]').href = product.url;
        if (announce) studio.querySelector('[data-st-wall-status]').textContent = `Affisch ${active + 1}: ${product.title}`;
      };
      slots.forEach((slot, i) => { slot.disabled = false; slot.addEventListener('click', () => { active = i; update(true); }); });
      positions.forEach((position, i) => position.addEventListener('click', () => { active = i; update(true); }));
      select.addEventListener('change', () => {
        const product = byHandle.get(select.value);
        if (!product) return;
        const slot = slots[active], img = slot.querySelector('img');
        slot.dataset.handle = product.handle;
        slot.setAttribute('aria-label', `Välj affisch ${active + 1}: ${product.title}`);
        img.removeAttribute('srcset'); img.src = product.image; img.alt = product.title;
        update(true);
      });
      studio.querySelectorAll('[data-st-tone]').forEach(button => button.addEventListener('click', () => {
        studio.dataset.tone = button.dataset.stTone;
        studio.querySelectorAll('[data-st-tone]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      studio.querySelectorAll('[data-st-wall-controls]').forEach(c => c.hidden = false);
      update();
    });
    root.querySelectorAll('[data-st-top]').forEach(a => {
      if (a.dataset.ready) return;
      a.dataset.ready = 'true';
      a.addEventListener('click', event => { event.preventDefault(); window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
